/**
 * Adapter: delegates IPolicyManager port to services/policyManager singleton.
 */
import type { Policy, PolicyChallenge, PolicyGameEffect } from '../../../types/policy';
import { policyManager, type PolicyManager } from '../../../services/policyManager';
import type { IPolicyManager } from '../../domain/ports/IPolicyManager';

export class PolicyManagerAdapter implements IPolicyManager {
  constructor(private readonly manager: PolicyManager = policyManager) {}

  createPolicy(templateId: string, customization: Partial<Policy>): Policy {
    return this.manager.createPolicy(templateId, customization);
  }

  approvePolicy(policyId: string, approver: string): Policy {
    return this.manager.approvePolicy(policyId, approver);
  }

  updatePolicy(policyId: string, updates: Partial<Policy>): Policy {
    return this.manager.updatePolicy(policyId, updates);
  }

  implementPolicy(policyId: string, implementer: string): Policy {
    return this.manager.implementPolicy(policyId, implementer);
  }

  enforcePolicy(policyId: string): Policy {
    return this.manager.enforcePolicy(policyId);
  }

  getPolicies(): Policy[] {
    return this.manager.getPolicies();
  }

  getChallenges(): PolicyChallenge[] {
    return this.manager.getChallenges();
  }

  calculateGameEffects(policyId: string): PolicyGameEffect {
    return this.manager.calculateGameEffects(policyId);
  }

  activateChallenge(challengeId: string): void {
    this.manager.activateChallenge(challengeId);
  }
}